/**
 * @file Builds a record with one entry per scope level from a per-level read.
 * Consumers: `useHomeAnalyticsSummary` and `useHomeGoalProgress`, which hold
 * one store, goal id or figure per level. Each level is read exactly once, in
 * `self`, `team`, `org` order.
 */
import type { AnalyticsScopeLevel } from '#types';

export const analyticsByLevel = <T>(
  read: (level: AnalyticsScopeLevel) => T,
): Record<AnalyticsScopeLevel, T> => ({
  self: read('self'),
  team: read('team'),
  org: read('org'),
});
